<template lang="pug">
	.section-container.section-home
		section.section.border-bottom-section.download-app-container
			.section-content(v-if="loadingPromoCode")
				.hourglass-outer
					hourglass

			.section-content(v-else)
				.columns.is-valigned-end
					.column.is-narrow.column-app-phone2
						img.block(src="/img/phone-it.png" :alt="$t('alt.app')" draggable="false")
					.column.column-app-phone1
						p.subtitle.no-line-break-mobile
							| {{ $t('home.subtitle_l1') }}
						
						.alert-box
							.split-container(v-if="!submittedCode" style="max-width:none;")
								.columns.is-centered.is-vcentered.is-multiline.margin-top-xs
									.column
										p.subtitle.no-line-break-mobile
											| {{ $t('profile.promo_code_help1a') }}
											strong {{ $t('profile.promo_code_help1b') }}

							.split-container(v-if="!submittedCode")
								.form-container
									.columns.is-centered.is-vcentered.is-multiline
										.column
											.field.has-addons
												p.control.has-icons-left.is-expanded
													input.input(
														ref="inputCode"
														type="text"
														:placeholder="$t('placeholder.promo_code')"
														maxlength="16"
														v-model="promo_code"
														v-on:keyup.enter="submitPromoCode")
													span.icon.is-small.is-left
														gift-icon(size="1.5x")
										.column.is-narrow
											.field
												p.control.has-text-centered
													button.button.is-primary(type="button" @click="submitPromoCode")
														| {{ $t('button.submit') }}

									article.message.is-danger(v-if="missingCode" transition="fade")
										.message-body
											| {{ $t('alert.missing_promo_code') }}
									article.message.is-danger(v-if="invalidCode" transition="fade")
										.message-body
											| {{ $t('alert.invalid_promo_code') }}
									article.message.is-danger(v-else-if="expiredCode" transition="fade")
										.message-body
											| {{ $t('alert.expired_promo_code') }}
									article.message.is-danger(v-else-if="errorPage" transition="fade")
										.message-body
											| {{ $t('alert.generic_error') }}

		section-video(:num="2")
		section-features(:num="3")
		section-luciano(:num="4")

		modal-comp.modal-video(ref="modalvideo" :title="$t('menu.video')" @close="videoPopupClosed")
			.columns.is-centered.is-vcentered(v-if="videoPopup")
				video(width="854" height="480" controls ref="playervideo")
					source(src="/videos/workout-ita.mp4" type="video/mp4")
					| {{ $t('home.no_video_support') }}

</template>

<script>
import TitleComponent from '../components/TitleComponent.vue'
import HourglassComponent from '../components/HourglassComponent.vue'
import { GiftIcon, XIcon } from 'vue-feather-icons'

import ModalComponent from '../components/ModalComponent.vue'
import SectionLuciano from '../components/sections/SectionLuciano.vue'
import SectionFeatures from '../components/sections/SectionFeatures.vue'
import SectionVideo from '../components/sections/SectionVideo.vue'

export default {
	components: {
		TitleComp: TitleComponent,
		Hourglass: HourglassComponent,
		ModalComp: ModalComponent,
		SectionLuciano,
		SectionFeatures,
		SectionVideo,
		GiftIcon,
		XIcon
	},
	data() {
		return {
			videoPopup      : false,
			promo_code      : '',
			submittedCode   : false,
			emptyPage       : false,
			missingCode     : false,
			expiredCode     : false,
			invalidCode     : false,
			errorPage       : false,
			loadingPromoCode: false,
			codeType        : null
		}
	},
	computed: {
		itLang() {
			return this.$t('locale.lang') === 'it'
		},
		language() {
			return this.$t('locale.lang')
		},
		accessToken() {
			return this.$store.state.auth.accessToken
		},
		userPromoCode() {
			return this.$store.state.user.userPromoCode
		}
	},
	mounted() {
		this.$meta().setOptions({ title: this.$t("title.promo_code") + ' | ' + this.$t("title.home") })
		if (this.accessToken) {
			this.$router.replace('/')
		}

		document.getElementsByTagName("BODY")[0].classList.add('page-header')

		if (this.userPromoCode) {
			this.promo_code = this.userPromoCode
		}
	},
	methods: {
		submitPromoCode() {
			if (!this.promo_code) {
				this.missingCode = true
				this.$refs.inputCode.focus()
				return
			}
			if (this.loadingPromoCode) return

			this.$store.commit('user/SET_USER_PROMO_CODE', this.promo_code)

			this.loadingPromoCode = true
			this.$store.dispatch('user/checkPromoCode', { 'code':  this.promo_code })
				.then(res => {
					if (res) this.codeType = res.type

					this.loadingPromoCode = false
					this.submittedCode = true
					this.errorPage = false
					this.missingCode = false
					this.invalidCode = false
					this.expiredCode = false

					this.$router.push('/promo-code-signup')
				})
				.catch(err => {
					this.loadingPromoCode = false
					if (err.response && err.response.status) {
						switch (err.response.status) {
							case 404:
								if (err.response.data) console.log(err.response.data)
								if (err.response.data && err.response.data.error_message === 'Expired Code') {
									this.expiredCode = true
								} else {
									this.invalidCode = true
								}
								break
							case 500:
							case 401:
								this.errorPage = true
								break
							default:
								console.warn(err.response.status)
						}
					}
				})
		},
		goSignup() {
			this.$router.push('/signup')
		},
		goLogin() {
			this.$router.push('/login')
		},
		openVideoPopup() {
			this.$refs.modalvideo.open()
			this.videoPopup = true
		},
		videoPopupClosed() {
			this.$refs.playervideo.pause()
		}
	},
	watch: {
		promo_code() {
			this.errorPage = false
			this.missingCode = false
			this.invalidCode = false
			this.expiredCode = false
		}
	}
}
</script>
